import { ONE_TB_IN_KB } from "../../../../utils/globalConsts";

/**
 * Checks if downgrading is allowed by checking used space with expected space
 */

const checkStorageIsOverflowed = (
  usedSpaceSize: number,
  // Put data for the next selected subscription if it is subscription downgrade
  subscriptionSpaceSize: number,
  // Put data for the new extra storage quantity if it is extra-storage downgrade
  extraStorageTBQuantity: number
) => {
  return (
    usedSpaceSize >
    subscriptionSpaceSize + extraStorageTBQuantity * ONE_TB_IN_KB
  );
};

export default checkStorageIsOverflowed;
